import { defineComponent as _defineComponent } from 'vue'
import { computed, ComputedRef } from "vue"

// Store
import store from "@/vue/planning/store/store"

// Enums
import { PaymentCondition } from "@/enums/paymentCondition"

// Components
import FlexiblePaymentCondition from "./FlexiblePaymentCondition.vue"
import FixedPaymentCondition from "./FixedPaymentCondition.vue"

// Props
interface Props {
	paymentCondition: number
	displayTitle: boolean
	cancellationDate: string
	isPVFlex?: boolean
	prestId?: string
	isDisplayPlaceholders?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PaymentCondition',
  props: {
    paymentCondition: null,
    displayTitle: { type: Boolean },
    cancellationDate: null,
    isPVFlex: { type: Boolean },
    prestId: null,
    isDisplayPlaceholders: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
	paymentCondition: number
	displayTitle: boolean
	cancellationDate: string
	isPVFlex?: boolean
	prestId?: string
	isDisplayPlaceholders?: boolean
};



// Computed
const startDate: ComputedRef<string> = computed(() => {
	return store.state.dates.BeginDate || ""
})

return { __sfc: true,props, startDate, store, PaymentCondition, FlexiblePaymentCondition, FixedPaymentCondition }
}

})